import React, { useState } from 'react';

interface AssemblyCodeFormProps {
  onCodeSubmit: (code: string) => void;
}

const AssemblyCodeForm: React.FC<AssemblyCodeFormProps> = ({ onCodeSubmit }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);

  // Validación en tiempo real
  const isValid = /^[a-zA-Z0-9]{6}$/.test(code);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValid) {
      setError('El código debe tener 6 caracteres alfanuméricos.');
      return;
    }
    setError(null);
    onCodeSubmit(code);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col items-center gap-4 p-6">
      <label className="text-lg font-semibold">Ingresa el código de la asamblea</label>
      <input
        type="text"
        maxLength={6}
        value={code.toUpperCase()}
        onChange={e => setCode(e.target.value.toUpperCase())}
        className={`border rounded px-4 py-2 text-center text-xl tracking-widest w-40 uppercase ${code && !isValid ? 'border-red-500' : ''}`}
        placeholder="ABC123"
        required
        autoComplete="off"
        inputMode="text"
      />
      {!isValid && code.length > 0 && (
        <span className="text-red-500 text-sm">Solo se permiten 6 letras y/o números</span>
      )}
      {error && <span className="text-red-500 text-sm">{error}</span>}
      <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded shadow hover:bg-blue-700" disabled={!isValid}>Acceder</button>
    </form>
  );
};

export default AssemblyCodeForm;
